import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { liveCleanroom } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from 'react-query';


export const useGetLcrWorksheetQueryResults = (
  lcrSessionId, worksheetId, queryId, options = {},
) => {
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);
  const {
    offset = 0,
    limit = 100,
    enabled = true,
  } = options;

  return useQuery(
    ['lcrWorksheetQueryResults', lcrSessionId, worksheetId, queryId, offset, limit],
    () => axiosInstance.get(
      liveCleanroom(orgId).getWorksheetQueryResults(lcrSessionId, worksheetId, queryId),
      { params: { offset, limit } },
    ),
    {
      enabled: enabled && !!lcrSessionId && !!queryId,
      select: (response) => response.data,
      onError: (error) => {
        dispatch(showAlert({
          message: error.response?.data?.message || 'Error fetching query results',
          type: 'error',
        }));
      },
    },
  );
};
